import React from "react";
import { Dialog, DialogContent, Typography, Grid, Box } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const scaleIn = keyframes`
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    background: "transparent",
    width: "calc(100% - 30px)",
    margin: "15px",
    boxShadow: "none",
    overflow: "visible",
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "20px",
  background: "#ffffff",
  padding: "35px 25px 25px 25px",
  width: "100%",
  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
  animation: `${scaleIn} 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) both`,
}));

const SuccessIconWrapper = styled(Box)({
  width: "72px",
  height: "72px",
  borderRadius: "50%",
  background: "#E8F5E9",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "20px",
  border: "4px solid #C8E6C9",
  color: "#2E7D32",
});

const BookingDonePopup = ({ open, onClose }) => {
  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <Grid
        container
        sx={{ background: "transparent", padding: "0 0 10px 0" }}
        justifyContent="end"
      >
        <CloseIcon
          sx={{
            fontSize: "30px",
            padding: "4px",
            color: "#ffffff",
            borderRadius: "50%",
            background: "rgba(0, 0, 0, 0.3)",
            cursor: "pointer",
            transition: "all 0.25s ease",
            "&:hover": {
              background: "rgba(0, 0, 0, 0.6)",
              transform: "scale(1.1)",
            },
          }}
          onClick={onClose}
        />
      </Grid>

      <DialogContent sx={{ padding: "0", overflow: "visible" }}>
        <ContentBox>
          <SuccessIconWrapper>
            <CheckCircleOutlineIcon sx={{ fontSize: 44 }} />
          </SuccessIconWrapper>

          <Typography
            variant="h5"
            fontWeight={800}
            sx={{
              color: "#1a1a2e",
              fontSize: "22px",
              mb: 1.5,
            }}
          >
            Booking Successful!
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#666",
              fontSize: "14px",
              lineHeight: 1.6,
              mb: 4,
              px: 1,
            }}
          >
            Your request has been submitted successfully
          </Typography>

          <button
            onClick={onClose}
            style={{
              width: "100%",
              padding: "12px 24px",
              background: "linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)",
              color: "#ffffff",
              border: "none",
              borderRadius: "12px",
              fontSize: "15px",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(46, 125, 50, 0.25)",
              transition: "all 0.2s ease",
              outline: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow =
                "0 6px 15px rgba(46, 125, 50, 0.35)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(46, 125, 50, 0.25)";
            }}
          >
            Done
          </button>
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  );
};

export default BookingDonePopup;
